<template>
  <div class="home-map-content">
    <div class="main">
      <vj-map ref="map"></vj-map>
      <router-view></router-view>
    </div>
    <div class="aside">
      <right-block></right-block>
    </div>
  </div>
</template>

<script>
import VjMap from '@/views/layout/map/VjMap'
import RightBlock from '@/views/layout/RightBlock'
export default {
  name: 'Map',
  components: {
    VjMap,
    RightBlock
  },
  data() {
    return {}
  },
  computed: {
  },
  watch: {
  },
  created() {
    // do something
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.home-map-content {
  height: 100%;
  display: flex;

  .main {
    flex: 1;
  }

  .aside {
    width: 320px;
    border-left: 1px solid #eee;
    overflow-y: auto;
  }
}
</style>
